import { bool } from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import FnrFade from "UI/FnrFade";
import { colors } from "UI/colors";

export default function ErrorMessage({ show, message }) {
  return (
    <FnrFade show={show}>
      <Div>{message}</Div>
    </FnrFade>
  );
}

ErrorMessage.propTypes = {
  show: bool,
};

const Div = styled.div`
  border: 1px solid ${colors.fnRedNotice};
  border-radius: 10px;
  background: ${colors.fnYellowNotice};
  color: ${colors.fnRedNotice};

  text-align: ${({ align }) => align};

  padding: 8px;
  font-size: 14px;
  font-weight: 400;
`;